import React, { useState, useEffect } from 'react';
import NavBar from './commonHooks/commonHooks.navBar'; 
import DataService from '../service/service.sql';
import './css/myRecap.css';

const MyRecap = () => {
    const [data, setData] = useState(null);
    const [expandedClass, setExpandedClass] = useState(false);
    const [expandedPlayer, setExpandedPlayer] = useState(false);
    const [expandedBoss, setExpandedBoss] = useState(false);

    const toggleExpandClass = () => {
        setExpandedClass(!expandedClass);
    };

    const toggleExpandPlayer = () => {
        setExpandedPlayer(!expandedPlayer);
    };

    const toggleExpandBoss = () => {
        setExpandedBoss(!expandedBoss);
    };

    const calcScore = () => {
        let baseScore = data.getTotalDuration.totalDuration / 1000000;
        baseScore *= data.getAverageGearScore.averageGearScore;
        baseScore *= (data.getNumberOfLogs.numberOfEncounters + data.getNumberOfLogs.numberOfUniqueEntities);
        baseScore *= data.getClearPercentData.clearPercent;
        baseScore *= Math.pow(100, data.getClearPercentData.clearPercentAlive);
        baseScore *= (data.getDamageStats.totalDamageDealtLocal / data.getDamageStats.totalDamageDealt);
        baseScore *= (1 - (data.getDeathTime.localDeathTime / data.getDeathTime.deathTime));

        return baseScore;
    };

    useEffect(() => {
        const getRecap = async () => {
            try {
                const store = await DataService.getRecap();
                setData(store.data.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        getRecap();
    }, []);

    const sendToLeaderboard = () => {
        const newDate = new Date().getTime()
        const leaderboardData = {
            dateUploaded:  newDate,
            score: calcScore(),
            clearPercent: data.getClearPercentData.clearPercent,
            clearPercentAlive: data.getClearPercentData.clearPercentAlive,
            duration: data.getTotalDuration.totalDuration,
            localDamage: data.getDamageStats.totalDamageDealtLocal,
            localDPS: data.getDamageStats.totalDPSLocal,
            percentDamage: (data.getDamageStats.totalDamageDealtLocal / data.getDamageStats.totalDamageDealt),
            percentDead: (data.getDeathTime.localDeathTime / data.getDeathTime.deathTime),
            logsStored: data.getNumberOfLogs.numberOfEncounters,
            uniquePlayers: data.getNumberOfLogs.numberOfUniqueEntities

        }
        DataService.sendToLeaderboard(leaderboardData)
    }

    const goToLeaderboard = async () => {
        sendToLeaderboard()
        window.location.href = '/leaderboard'
    }

    return data && (
        <div className='app-container'>
            <NavBar />
            <div className='recap-container'>
                <h1>Your Lost Ark Recapped</h1>
                <h2>Total Time In Raids: {Math.round(data.getTotalDuration.totalDuration / 360000) / 10} hours</h2>
                <h2>You had a total of {data.getNumberOfLogs.numberOfEncounters} logs stored 
                    meeting {data.getNumberOfLogs.numberOfUniqueEntities} unique players!
                </h2>
                {data.getClassDist.classDist.length > 3 && (
                        <button onClick={toggleExpandClass}>
                            {expandedClass ? 'Show less' : 'Show more'}
                        </button>
                    )}
                <h3>
                    <table>
                        <thead>
                            <tr>
                                <th>Class</th>
                                <th>Frequency</th>
                            </tr>
                        </thead>
                        <tbody>
                            {expandedClass ? (
                                data.getClassDist.classDist.map((classData, index) => (
                                    <tr key={index}>
                                        <td>{classData.class}</td>
                                        <td>{classData.frequency}</td>
                                    </tr>
                                ))
                            ) : (
                                data.getClassDist.classDist.slice(0, 3).map((classData, index) => (
                                    <tr key={index}>
                                        <td>{classData.class}</td>
                                        <td>{classData.frequency}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>

                </h3>
                <h3> Average Gear Score Overall: {Math.round(data.getAverageGearScore.averageGearScore)}</h3>
                
                <h3> You cleared {Math.round(data.getClearPercentData.clearPercent * 1000) / 10}% of encounters</h3>
                <h3> However, you were only alive for {Math.round(data.getClearPercentData.clearPercentAlive * 1000) / 10}% of encounter clears</h3>

                <h3>
                    The total damage dealt in your encounters was: {Math.round(data.getDamageStats.totalDamageDealt / 100000000) / 10} Billion (
                    {Math.round(data.getDamageStats.totalDPS / 100000) / 10} Million DPS Average)
                </h3>
                <h3>
                    and you did: {Math.round(data.getDamageStats.totalDamageDealtLocal / 100000000) / 10} Billion (
                    {Math.round(data.getDamageStats.totalDPSLocal / 100000) / 10} Million DPS Average)
                </h3>
                <h3>
                    Which is: {Math.round((data.getDamageStats.totalDamageDealtLocal / data.getDamageStats.totalDamageDealt) * 1000) / 10}% of the total damage.
                </h3>

                <h3>
                    In total, people tanked {Math.round(data.getDamageStats.totalDamageTaken / 100000) / 10} Million damage 
                    with you tanking, {Math.round(data.getDamageStats.totalDamageTakenLocal / 100000) / 10} Million Damage. 
                    ({Math.round((data.getDamageStats.totalDamageTakenLocal / data.getDamageStats.totalDamageTaken) * 1000) / 10}%)
                </h3>

                <h3>
                    In your runs, people spent {Math.round((data.getDeathTime.deathTime) / 360000) / 10} hours being dead,
                </h3>
                <h3>
                    You spent {Math.round((data.getDeathTime.localDeathTime) / 360000) / 10} hours being dead. ({Math.round((data.getDeathTime.localDeathTime / data.getDeathTime.deathTime) * 1000) / 10}%)
                </h3>

                <button onClick={toggleExpandPlayer}>
                    {expandedPlayer ? 'Show less' : 'Show more'}
                </button>

                <h3>
                    You had the most logs playing as {data.getLogsPerLocalPlayer.logsPerLocalPlayer[0].local_player} ({data.getLogsPerLocalPlayer.logsPerLocalPlayer[0].frequency})
                    {expandedPlayer && (
                        <table>
                            <thead>
                                <tr>
                                    <th>Player</th>
                                    <th>Frequency</th>
                                </tr>
                            </thead>
                            <tbody>
                                {expandedPlayer && (
                                    data.getLogsPerLocalPlayer.logsPerLocalPlayer.map((logData, index) => (
                                        <tr key={index}>
                                            <td>{logData.local_player}</td>
                                            <td>{logData.frequency}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    )}
                </h3>

                
                <button onClick={toggleExpandBoss}>
                    {expandedBoss ? 'Show less' : 'Show more'}
                </button>
                <h3>
                    And the boss you fought the most was {data.getNumberOfBossFights.numberOfBossFights[0].current_boss} ({data.getNumberOfBossFights.numberOfBossFights[0].frequency})
                    {expandedBoss && (
                        <table>
                            <thead>
                                <tr>
                                    <th>Boss</th>
                                    <th>Frequency</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.getNumberOfBossFights.numberOfBossFights.map((bossData, index) => (
                                    <tr key={index}>
                                        <td>{bossData.current_boss}</td>
                                        <td>{bossData.frequency}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                )}
                </h3>


                <h2>
                    Overall your score is: {Math.round(calcScore())}
                </h2>

                {/* <h4>
                    Note: This is very inaccurate at the moment as it includes all encounters no matter if it is a boss or not.
                    Also, if you play a support (or multiple), your stats are going to be worse as the DPS is skewed lower by it.
                    Later, features will be added to change this eventually...
                    UI WIP!!!
                </h4> */}
                <button onClick={goToLeaderboard}>
                    Check Where You Place On The Leaderboard!
                </button>
            </div>
        </div>
    );
};

export default MyRecap;
